import hide from '!!raw-loader!!!./hideC8.css'

export const c8RawCss = {
  hideGuiElements: hide,

}


// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexComponents/content-panels/c8-component-wrappers/index.ts